export const INITIAL_VALUES = { confirmationText: "" };
